<template>
  <div class="overdue-nofollowed">
    <!-- 逾期未跟进门店 -->
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.overdueStoreFailureToFollowUp')">
      <div class="right-header">
        <img class="search-img icon-img" src="@/assets/images/search_news.png" alt="" @click="toPage(`/overdueNoFollowed/search`)">
      </div>
    </NavHeaderBar>
    <div class="tabs-content">
      <van-sticky :offset-top="48">
        <FilterCustom :ref="`filterCustom`" :pageType="pageType" :deptOption="deptOption" @changeFilter="confirmFilter" />
      </van-sticky>
      <van-pull-refresh v-model="isLoading" @refresh="pullDownRefreshFn">
        <van-list v-model="loading" :finished="finished" :finished-text="$t('tips.nothingMore')" offset="60" :immediate-check="false" @load="pullUpLoadMoreFn">
          <div v-for="subItem in storeList" :key="subItem.id" clickable class="store-item-info" @click="toDetail(subItem)">
            <div v-if="[1, '1', 2].includes(subItem.customerTag) && subItem.imgUrl" class="img-bc">
              <img v-if="subItem.imgUrl" class="custom-img" :src="subItem.imgUrl" alt="" @click.stop="imgPreview(subItem.imgUrl)">
              <img v-else class="custom-img" src="@/assets/images/icon_noimg.png" alt="">
              <img v-if="[1, '1'].includes(subItem.customerTag)" class="mark-img" src="@/assets/images/u93.png" alt="">
            </div>
            <img v-else-if="subItem.imgUrl" class="store-img" :src="subItem.imgUrl" alt="" @click.stop="imgPreview(subItem.imgUrl)">
            <img v-else class="store-img" src="@/assets/images/icon_noimg.png" alt="">
            <div class="right-section">
              <div class="store-name txt-ellipsis">{{ subItem.customerName }}</div>
              <div class="ba-name txt-ellipsis" v-if="subItem.dutyName">{{ $t('shared.bA') }}：{{ subItem.dutyName }}</div>
              <div class="last-activity" v-if="subItem.lastOperationType"><span class="font-text">{{ subItem.lastOperationType }}</span> {{ $t('shared.byVisitBy') }} {{ subItem.operationUserName }} <span class="font-text">{{ subItem.visitDifferDay | formatTime }}</span> <span v-show="subItem.visitDifferDay > 1">{{ $t('shared.daysAgo') }}</span></div>
              <div class="basic-info">
                <span class="city-name txt-ellipsis" v-if="subItem.city">{{ subItem.city }}</span>
                <span class="address txt-ellipsis">{{ subItem.address }}</span>
                <img v-if="subItem.lat" class="nav-path-img" src="@/assets/images/daohan1.png" alt="" @click.stop="getCurrentLoc(subItem)">
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { deptTreeDeptApi } from '@/api/home'
import { customerOverdueListPageApi } from '@/api/overdueNoFollowed'
import { Toast, ImagePreview } from 'vant'
import FilterCustom from '@/components/FilterCustom'
import { mapState } from 'vuex'
import i18n from '@/i18n'
export default {
  name: 'OverdueNoFollowed',
  components: {
    FilterCustom
  },
  filters: {
    formatTime (val) {
      return val === 0 ? i18n.t('shared.today') : val === 1 ? i18n.t('shared.yesterday') : val
    }
  },
  data () {
    return {
      isLoading: false, // 下拉的加载状态
      loading: false, // 上拉每一页的加载状态
      finished: false, // 上拉是否全部加载完毕
      storeList: [], // 文字列表
      paginationList: {
        page: 1,
        limit: 10,
        total: 0
      },
      geocoder: null,
      pageType: 'store',
      deptOption: [],
      filterData: {
        sortVal: 'distance-0',
        sortLabel: this.$t('shared.filter.distanceNearest'),
        customerTag: '',
        shelfOperate: '',
        shelfProductIdList: [],
        deptIdList: [],
        userIdList: [],
        personVal: [],
        incentiveType: '',
        isPopUpEvent: ''
      }
    }
  },

  watch: {
    $route (newVal) {
      this.$nextTick(() => {
        if (this.$route.meta.scrollY) {
          window.scrollTo(0, this.$route.meta.scrollY)
        }
      })
    }
  },

  // 路由离开前
  beforeRouteLeave (to, from, next) {
    // 可以访问组件实例 `this`
    // 把滚动的高度 保存到 路由对象的meta字段中的scrollY上
    from.meta.scrollY = window.scrollY
    next()
  },
  // mounted() {
  //   console.log('mounted')
  //   // this.geocoder = new google.maps.Geocoder()
  // },
  activated () {
    // 一进入Home页面，需要立即 发送请求，拿数据，铺页面
    // this.getStoreData()
    // 页面切回来，自动滚动到 上次 保存的 滚动位置
    // window.scrollTo(x, y)
    // this.$nextTick(() => {
    //   window.scrollTo(0, this.$route.meta.scrollY)
    // })
    this.paginationList.page = 1
    this.getMyVisit()
    this.resetPage()
    this.isLoading = false
    // this.filterData.projectId = this.globalData.projectList[0].id
    // this.filterData.projectName = this.globalData.projectList[0].projectName
    // this.$refs[`filterCustom`].setDefaultVal('projectId', this.globalData.projectList[0])
    this.getStoreData()
    // this.pullDownRefreshFn()
  },
  computed: {
    ...mapState({
      userInfo: 'myUserInfo',
      globalData: 'globalData'
    })
  },
  methods: {
    toDetail (item) {
      this.$router.push(`/storeMaintain/storeMappingDetail?customerId=${item.id}&pageType=storeMaintain`)
    },
    getCurrentLoc (params) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getlocation(currentTimeLoc.lat, currentTimeLoc.lng, params.address)
    },
    getlocation (lat, lng, toAddress) {
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${toAddress}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    confirmFilter (data) {
      this.filterData = data
      this.paginationList.page = 1
      this.storeList = []
      this.finished = false
      this.loading = false
      this.getStoreData(true)
      this.isLoading = false
    },
    // 获取频道文字列表xxxaaaxx
    async getStoreData (isPullDown = false) {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 三星手机不能频繁获取当前定位
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getStoreListData(currentTimeLoc)
    },
    getStoreListData (currentTimeLoc = {}) {
      const {
        personVal,
        userIdList,
        sortVal
      } = this.filterData
      const data = {
        ...this.paginationList,
        ...this.filterData,
        userIdList: personVal.includes('Me')
          ? [...userIdList, this.userInfo.user.id]
          : userIdList,
        sortField: sortVal ? sortVal.split('-')[0] : '',
        order: sortVal ? sortVal.split('-')[1] : '',
        ...currentTimeLoc,
        search: ''
      }
      customerOverdueListPageApi(data)
        .then((result) => {
          Toast.clear()
          if (this.paginationList.page === 1) {
            this.storeList = []
          }
          // 没有就去请求
          this.paginationList.total = result.data.totalRow
          // 把新数组 与 原来的 数组 进行 合并
          this.storeList = [...this.storeList, ...result.data.list]
          // 把 loading 设置为false，表示 可以进行 下一次请求了
          this.paginationList.page++
          this.loading = false
          if (this.storeList.length === Number(this.paginationList.total)) {
            this.finished = true
          }
        })
        .catch(() => {})
    },

    // 上拉加载更多
    pullUpLoadMoreFn () {
      // 切换频道的时候，只有articleList 不为空，才触发 上拉加载更多的函数
      if (this.storeList.length > 0) {
        // 1. 发请求 2. 拿数据，合并
        this.getStoreData()
      }
    },
    getMyVisit () {
      deptTreeDeptApi().then((res) => {
        this.deptOption = this.stripInPlace(res.data)
      })
    },
    stripInPlace (list) {
      list.forEach((node) => {
        if (Array.isArray(node.children)) {
          if (node.children.length) {
            this.stripInPlace(node.children)
          } else {
            delete node.children
          }
        }
      })
      return list
    },
    // 下拉刷新
    pullDownRefreshFn () {
      // this.storeList = []
      this.resetPage()
      this.getStoreData(true)
      this.isLoading = false
    },
    resetPage () {
      this.paginationList = {
        page: 1,
        limit: 10,
        total: 0
      }
      this.storeList = []
      this.finished = false
      this.loading = false
    },
    updateData (index) {
      this.storeList.splice(index, 1)
    },
    toPage (url) {
      if (!url) return
      this.$router.push(url)
    },
    imgPreview (url) {
      ImagePreview([url])
    }
  }
}
</script>

<style scoped lang="less">
.overdue-nofollowed {
  height: 100%;
  background-color: #f5f5f9;
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .img-bc {
    position: relative;
    width: 65px;
    height: 65px;
    padding: 9px;
    background: url('~@/assets/images/u91.png') no-repeat;
    background-size: 65px 65px;
  }
  //  /deep/.van-cell {
  //    padding: 10px;
  //    .van-cell__title {
  //      padding-top: 20px;
  //      flex: none;
  //    }
  //    .van-cell__value {
  //      padding-left: 10px;
  //      text-align: left;
  //      color: #000;
  //    }
  //  }
  .store-item-info {
    display: flex;
    padding: 10px;
    .store-img {
      width: 62px;
      height: 62px;
      object-fit: cover;
    }
    .mark-img {
      position: absolute;
      bottom: 0;
      right: 4px;
      width: 24px;
      height: 30px;
      transform: rotate(-26deg);
    }
    .custom-img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 53px;
      height: 53px;
      object-fit: cover;
    }
    .right-section {
      flex: 1;
      line-height: 20px;
      margin-left: 10px;
      .store-name {
        max-width: 261px;
        font-size: 15px;
        font-weight: bold;
      }
      .ba-name {
        max-width: 261px;
        font-size: 12px;
      }
      .last-activity {
        .font-text {
          color: #307bff;
          font-weight: bold;
        }
      }
      .basic-info {
        width: 276px;
        display: flex;
        align-items: center;
        .city-name {
          max-width: 80px;
          padding: 0px 2px;
          background-color: #9d6600;
          color: #fff;
          font-size: 10px;
        }
        .address {
          // width: 186px;
          flex: 1;
          padding: 0 3px;
          padding-left: 0;
          font-size: 12px;
        }
        .nav-path-img {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
  .tabs-content {
    width: 100%;
    padding-bottom: 43px;
  }
  /deep/.van-pull-refresh {
    .van-list {
      background-color: #fff;
    }
  }
  /deep/.van-sticky {
    z-index: 999;
  }
}
</style>
